import Actions from './actions';

import * as Reducers from './reducers';

import ProtectedRoute from '../../components/ProtectedRoute';
import SupportPage from './components/SupportPage';

import { SUPPORT_PATH } from '../../constants/routes';

const Routes = [
  {
    path: SUPPORT_PATH,
    Component: ProtectedRoute,
    children: [
      {
        index: true,
        Component: SupportPage,
      },
    ],
  },
];

export default {
  Actions,
  Reducers,
  Routes,
};
